"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import { memo } from "react"
import { sharedColors } from "ui/theme/colors"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"
import { GalleryImage } from "./Gallery"

const StyledImagesGrid = styled.div`
  display: grid;
  gap: 16px;
  padding-right: 16px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-right: max(88px, calc((100vw - 1280px) / 2 + 88px));
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    padding-right: max(200px, calc((100vw - 1920px) / 2 + 200px));
  }
`

const StyledImagesInnerGrid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, 1fr);
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 24px;
  }
`

const MainImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 278px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid ${sharedColors.borderGray};
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 494px;
  }
`

const SmallImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 136px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid ${sharedColors.borderGray};
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 235px;
  }
`

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(5, 23, 17, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

function Gallery({
  galleryImages,
  openLightbox,
}: {
  galleryImages: GalleryImage[]
  openLightbox: (index: number) => void
}) {
  return (
    <StyledImagesGrid>
      <MainImageContainer onClick={() => openLightbox(0)}>
        <Image
          src={getUmbracoMediaUrl(galleryImages[0].url)}
          alt={galleryImages[0].altText || ""}
          objectFit="cover"
          fill
        />
      </MainImageContainer>
      <StyledImagesInnerGrid>
        {galleryImages.slice(1, 5).map((image, index) => (
          <SmallImageContainer
            key={index}
            onClick={() => openLightbox(index + 1)}
          >
            {index === 3 && galleryImages.length > 5 ? (
              <Backdrop>
                <Typography variant="h3" color="white">
                  {galleryImages.length - 5}+
                </Typography>
              </Backdrop>
            ) : null}
            <Image
              src={getUmbracoMediaUrl(image.url)}
              alt={image.altText || ""}
              objectFit="cover"
              fill
            />
          </SmallImageContainer>
        ))}
      </StyledImagesInnerGrid>
    </StyledImagesGrid>
  )
}

export default memo(Gallery)
